<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="copy">This edition published in Great Britain in 2021<br/>under license from Whittles Publishing by<br/>Birlinn Ltd</p>
<p class="copy">West Newington House</p>
<p class="copy">10 Newington Road</p>
<p class="copy">Edinburgh</p>
<p class="copy">EH9 1QS</p>
<p class="copy1"><a href="http://www.birlinn.co.uk" target="_blank">www.birlinn.co.uk</a></p>
<p class="copy1">ISBN: 978 1 78027 703 5<br/>ePUB ISBN: 978 1 78885 449 8</p>
<p class="copy1">Copyright © The estate of Mike Tomkies<br/>Introduction copyright © Jim Crumley 2017<br/>First published in 1984 by Jonathan Cape</p>
<p class="copy1">Subsequently published by Whittles Publishing, Dunbeath in 2017</p>
<p class="copy1"><em>British Library Cataloguing-in-Publication Data</em></p>
<p class="copy1">A catalogue record for this book is available on request from the British Library</p>
<p class="copy">Papers used by Birlinn are from well-managed forests and other responsible sources</p>
<p class="image"><img alt="Illustration" src="images/pub.png"/></p>
<p class="copy1">Typeset by Hewer Text UK, Edinburgh<br/>Printed and bound by Clays Ltd, Elcograf S.p.A.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5a4eb6ea